import logger from './utils/logger';

/**
 * Core Web Vitals reporting.
 *
 * `web-vitals` was already a dependency but was never imported, so no field performance
 * data was ever collected. Metrics are forwarded to Google Analytics (already loaded via
 * gtag in public/index.html) when present, and logged in development.
 *
 * Note: this uses the web-vitals v6 API (`onCLS`/`onINP`/...). FID was retired in favour
 * of INP, so the metric set differs from CRA's original scaffold.
 */
const sendToAnalytics = (metric) => {
    const { name, delta, value, id, rating } = metric;

    logger.log(`web-vital ${name}`, Math.round(value), rating);

    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', name, {
            event_category: 'Web Vitals',
            // CLS is a unitless ratio; the others are milliseconds. GA wants integers.
            value: Math.round(name === 'CLS' ? delta * 1000 : delta),
            event_label: id,
            metric_rating: rating,
            non_interaction: true,
        });
    }
};

const reportWebVitals = (onPerfEntry = sendToAnalytics) => {
    if (typeof onPerfEntry !== 'function') return;

    import('web-vitals')
        .then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
            onCLS(onPerfEntry);
            onFCP(onPerfEntry);
            onINP(onPerfEntry);
            onLCP(onPerfEntry);
            onTTFB(onPerfEntry);
        })
        .catch((error) => {
            logger.log('web-vitals failed to load', error?.message);
        });
};

export default reportWebVitals;
